// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"a67e96c9dce8a24f6f82","231":"ca4f0f27993e27577bf0","589":"2a34f58524029e2072f1","610":"f52d6d6d69120098089e","691":"aa657ce4818c1d1994bb","898":"35c4994db77569e68148"}[chunkId] + ".js";
};